<form [formGroup]="formGroup">
	<div class="bg-off-white px-48px pt-24px pb-36px">
		<div class="flex justify-between mb-24px">
			<div></div>
			<h1 class="text-font-24 text-dark-grey font-DIN-bold">
				{{ 'STORE.UPDATE_STATUS_POPUP.UPDATE_STATUS' | translate }}
			</h1>
			<div (click)="closeDialog()">
				<img
					class="ml-[100%] cursor-pointer"
					src="assets/images/close-square.svg"
					alt=""
				/>
			</div>
		</div>
		<p>{{ 'GENERAL_LABELS.STATUS' | translate }}</p>
		<mat-form-field appearance="outline" class="w-full custom-autocomplete">
			<mat-select
				formControlName="newStatus"
				(selectionChange)="changeOrderStatus()"
				panelClass=" my-0 mx-24px "
				placeholder="{{
					data?.current
						? ('STATUS.' + currentStatus[0].name | translate)
						: ('GENERAL_LABELS.STATUS' | translate)
				}}"
			>
				<mat-select-trigger class="text-main-color-black">
					{{ 'STATUS.' + getController('newStatus')?.value?.name | translate }}
				</mat-select-trigger>

				<ng-container *ngFor="let status of statusList">
					<mat-option [value]="status">
						{{ 'STATUS.' + status?.name?.toString() | translate }}
					</mat-option>
				</ng-container>
				<mat-option disabled class="only-check" *ngIf="!statusList?.length">
					{{ 'STORE.ADD_PRODUCT.NO_CATEGORY_FOUND' | translate }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<ng-container *ngIf="showInput && label == 'REASON'">
			<mat-form-field appearance="outline" class="w-full">
				<mat-label>{{
					'GENERAL_LABELS.' + label.toLocaleUpperCase() | translate
				}}</mat-label>
				<input
					formControlName="reason"
					required
					matInput
					placeholder="{{
						'GENERAL_LABELS.' + label.toLocaleUpperCase() | translate
					}}"
				/>
			</mat-form-field>
		</ng-container>
		<ng-container *ngIf="showInput && label == 'date'">
			<mat-form-field class="w-full" appearance="outline">
				<mat-label>{{
					'GENERAL_LABELS.' + label.toLocaleUpperCase() | translate
				}}</mat-label>
				<input formControlName="date" matInput [matDatepicker]="picker" />

				<mat-datepicker-toggle
					matIconSuffix
					[for]="picker"
				></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>
		</ng-container>
		<ng-container *ngIf="showInput && label == 'AWB'">
			<mat-form-field appearance="outline" class="w-full">
				<mat-label>{{
					'GENERAL_LABELS.' + label.toLocaleUpperCase() | translate
				}}</mat-label>
				<input
					formControlName="awb"
					required
					matInput
					placeholder="{{
						'GENERAL_LABELS.' + label.toLocaleUpperCase() | translate
					}}"
				/>
			</mat-form-field>
		</ng-container>

		<div class="mt-24px">
			<button
				mat-button
				[disabled]="formGroup.invalid"
				(click)="confirm()"
				class="w-full bg-gradient text-off-white py-[25px] rounded-6px mb-[10px]"
			>
				{{ 'ACTIONS.UPDATE' | translate }}
			</button>
			<button
				(click)="closeDialog()"
				class="w-full py-[15px] border-[1px] border-secondry-color-Gray text-dark-grey rounded-6px"
			>
				{{ 'ACTIONS.CANCEL' | translate }}
			</button>
		</div>
	</div>
</form>
